import React from 'react'

import { formatarMilharSemDecimais } from '../../../utils/formatarMilhar'

export default function LinhaLegenda({ clienteAlgar, itemContrato, cor1 }) {
  return (
    <div className="linha-legenda-operadoras">
      <div className="coluna-legenda-operadoras-1">
        <div
          className="esfera-legenda-dashboard"
          style={{
            backgroundColor: clienteAlgar ? cor1 : itemContrato.cor
          }}
        />
        <div className="coluna-legenda-operadoras-2">
          <span className="fonte-cor-1 texto-legenda-operadoras">
            {itemContrato.label}
          </span>
        </div>
      </div>
      <div className="coluna-legenda-operadoras-3">
        <span className="fonte-cor-1 texto-legenda-operadoras-numero">
          {formatarMilharSemDecimais(itemContrato.value)}
        </span>
      </div>
    </div>
  )
}
